import Axios from "axios";
import { createAction } from "@coverme/redux";
import { getIsFullyCovered } from "./interviewActions";

export const getNotifications = () => {
    return createAction("GET_NOTIFICATIONS", () => {
        return Axios.get(`/api/notifications`).then(result => {
            return result.data;
        });
    });
};

export const markNotificationAsRead = notificationId =>
    createAction("NOTIFICATION_READ", (dispatch, getState) => {
        return Axios.put("api/notifications/" + notificationId).then(result => {
            dispatch(getNotifications());
            return result.data;
        });
    });
